export default "<app-url-viewer [urlItem]=\"urlItem\" [verbose]=\"verbose\" [width]=\"width\" [height]=\"height\"></app-url-viewer>"